// extracted by mini-css-extract-plugin
module.exports = {"procedureName":"styles_procedureName__2hcGr","colMin":"styles_colMin__2BEF-","colCheckbox":"styles_colCheckbox__1Vi7c"};